/**
 * Titanoré Labs — Cart Fase 2 upgrade replace.
 * Removes the eligible line, adds Chef's Pan Set van 3, re-renders from Shopify.
 * Does not change Fase 1 discount math.
 */
(function () {
  if (window.__tlCartFase2) return;
  window.__tlCartFase2 = true;

  var rootSelector = ".tl-cart-fase1";

  function root() {
    return document.querySelector(rootSelector);
  }

  function withJs(url) {
    if (!url) return "";
    return url.indexOf(".js") !== -1 ? url : url + ".js";
  }

  function changeUrl() {
    var routes = window.routes || {};
    if (routes.cart_change_url) return withJs(routes.cart_change_url);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return base + "cart/change.js";
  }

  function addUrl() {
    var routes = window.routes || {};
    if (routes.cart_add_url) return withJs(routes.cart_add_url);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return base + "cart/add.js";
  }

  function parseJson(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function showError(message) {
    var el = document.querySelector("[data-tl-cart-error]");
    if (el) el.textContent = message || "";
  }

  function replaceSection(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector(rootSelector);
    var current = root();
    if (!next || !current) return false;
    current.replaceWith(next);
    return true;
  }

  function replaceBubble(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next =
      doc.getElementById("shopify-section-cart-icon-bubble") ||
      doc.querySelector(".shopify-section-cart-icon-bubble") ||
      doc.querySelector("#cart-icon-bubble") ||
      doc.querySelector(".cart-count-bubble") ||
      doc.body.firstElementChild;
    var current =
      document.getElementById("shopify-section-cart-icon-bubble") ||
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector(".shopify-section-cart-icon-bubble");
    if (next && current) current.innerHTML = next.innerHTML;
  }

  function setBusy(busy) {
    var el = root();
    if (el) el.classList.toggle("is-updating", !!busy);
    var box = document.querySelector("[data-tl-cart2]");
    if (box) box.classList.toggle("is-busy", !!busy);
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.text().then(function (text) {
        return { ok: res.ok, data: parseJson(text) };
      });
    });
  }

  function sectionPayload(extra) {
    var el = root();
    var sectionId = el ? el.getAttribute("data-section-id") : "";
    var sections = [];
    if (sectionId) sections.push(sectionId);
    sections.push("cart-icon-bubble");
    extra.sections = sections;
    extra.sections_url = window.location.pathname || "/cart";
    return { payload: extra, sectionId: sectionId };
  }

  function applyCart(data, sectionId) {
    var html = sectionId && data.sections ? data.sections[sectionId] : null;
    if (!replaceSection(html)) {
      window.location.reload();
      return;
    }
    replaceBubble(data.sections && data.sections["cart-icon-bubble"]);
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
  }

  function replaceLine(removeKey, addId) {
    var packed = sectionPayload({
      items: [{ id: Number(addId), quantity: 1 }]
    });

    setBusy(true);
    showError("");

    postJson(addUrl(), packed.payload)
      .then(function (added) {
        var data = added.data || {};
        if (!added.ok || data.status === 422 || data.errors || data.description) {
          throw new Error(data.description || data.message || "add");
        }
        var addedKey = (data.items && data.items[0] && data.items[0].key) || data.key;
        return postJson(
          changeUrl(),
          sectionPayload({
            id: removeKey,
            quantity: 0
          }).payload
        ).then(function (changed) {
          return { changed: changed, addedKey: addedKey };
        });
      })
      .then(function (result) {
        var changed = result.changed;
        var data = changed.data || {};
        if (!changed.ok || data.errors || data.description) {
          if (result.addedKey) {
            return postJson(
              changeUrl(),
              sectionPayload({
                id: result.addedKey,
                quantity: 0
              }).payload
            ).then(function () {
              throw new Error(data.errors || data.description || "change");
            });
          }
          throw new Error(data.errors || data.description || "change");
        }
        applyCart(data, packed.sectionId);
      })
      .catch(function () {
        var elNow = root();
        var fallback =
          (elNow && elNow.getAttribute("data-error")) ||
          "Cart update failed.";
        showError(fallback);
        setBusy(false);
      });
  }

  document.addEventListener("click", function (event) {
    var action = event.target.closest("[data-tl-cart2-replace]");
    if (!action || !event.target.closest(rootSelector)) return;
    var key = action.getAttribute("data-remove-key");
    var addId = action.getAttribute("data-add-id");
    if (!key || !addId) return;
    event.preventDefault();
    if (action.getAttribute("aria-disabled") === "true") return;
    action.setAttribute("aria-disabled", "true");
    replaceLine(key, addId);
  });
})();
